module.exports = __webpack_public_path__ + "static/media/loc1_img32.37552bd4.jpg";